export default "__VITE_ASSET__Bp7fQUld__"